// extracted by mini-css-extract-plugin
module.exports = {"contextMenuButton":"DevicesTableRowMenu_contextMenuButton__38kZs","contextMenu":"DevicesTableRowMenu_contextMenu__1eeW9","contextIcon":"DevicesTableRowMenu_contextIcon__2jF61"};